import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { BrowserRouter, Route, Routes, Outlet, useLocation } from "react-router-dom";


//layouts
import { Mainheader } from "./../layouts/Header";
import Footer2 from "../layouts/Footer2";
import ScrollToTop from "./../layouts/ScrollToTop";
import Header2 from "../layouts/Header2";

//Pages (lazy-loaded for code splitting)
const AboutUs = lazy(() => import("./AboutUs"));
const Team = lazy(() => import("./Team"));
const Faq = lazy(() => import("./Faq"));
const ErrorPage = lazy(() => import("./ErrorPage"));
const UnderConstruction = lazy(() => import("./UnderConstruction"));
const ComingSoon = lazy(() => import("./ComingSoon"));
const ServicesDetails = lazy(() => import("./ServicesDetails"));
const BlogGrid = lazy(() => import("./BlogGrid"));
const BlogLargeSidebar = lazy(() => import("./BlogLargeSidebar"));
const BlogListSidebar = lazy(() => import("./BlogListSidebar"));
const BlogDetail = lazy(() => import("./BlogDetail"));
const WeightCalculator = lazy(() => import("./WeightCalculator"));
const ContactUs = lazy(() => import("./ContactUs"));
const Home2 = lazy(() => import("./Home2"));
const Home3 = lazy(() => import("./Home3"));
const TermsConditions = lazy(() => import("./TermsConditions"));
const PrivacyPolicy = lazy(() => import("./PrivacyPolicy"));
const Schedule = lazy(() => import("./Schedule"));

// Admin dashboard — its own layout, code-split away from the public site
const AdminApp = lazy(() => import("../admin/AdminApp"));

function Index() {
  var baseName = "/";
  return (
    <BrowserRouter basename={baseName}>
      <Suspense fallback={null}>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/error-404" exact element={<ErrorPage />} />
          <Route path="/under-maintenance" exact element={<UnderConstruction />} />
          <Route path="/coming-soon" exact element={<ComingSoon />} />
          <Route path="/" exact element={<Home2 />} />
          <Route path="/about-us" exact element={<AboutUs />} />
          <Route path="/team" exact element={<Team />} />
          <Route path="/faq" exact element={<Faq />} />
          <Route path="/services-details" exact element={<ServicesDetails />} />
          <Route path="/schedule" exact element={<Schedule />} />
          <Route path="/blog-grid" exact element={<BlogGrid />} />
          <Route
            path="/blog-large-sidebar"
            exact
            element={<BlogLargeSidebar />}
          />
          <Route
            path="/wellness-journal"
            exact
            element={<BlogListSidebar />}
          />
          <Route path="/blog-details/:slug" element={<BlogDetail />} />
          <Route
            path="/weight-calculator"
            exact
            element={<WeightCalculator />}
          />
          <Route path="/contact-us" exact element={<ContactUs />} />
          <Route path="/terms-conditions" exact element={<TermsConditions />} />
          <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
        </Route>
        <Route element={<MainLayout2 />}>
          <Route path="/home-2" exact element={<Home2 />} />
        </Route>
        <Route element={<MainLayout3 />}>
          <Route path="/home-3" exact element={<Home3 />} />
        </Route>

        {/* Admin dashboard — no site header/footer */}
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
      </Suspense>
      {/* <Switcher /> */}
      <ScrollToTop />
      <SiteWidgets />
    </BrowserRouter>
  );
}

/** WhatsApp + back-to-top buttons: public pages only, never over the dashboard. */
function SiteWidgets() {
  const { pathname } = useLocation();
  const scrollTopBtn = useRef(null);

  useEffect(() => {
    window.onscroll = null;
    const handleScroll = () => {
      if (!scrollTopBtn.current) return;
      scrollTopBtn.current.classList.toggle("d-block", window.scrollY > 650);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.onscroll = null;
    };
  }, []);

  if (pathname.startsWith("/admin")) return null;

  return (
    <>
      <a
        href="https://wa.me/966575755700"
        target="_blank"
        rel="noreferrer"
        className="whatsapp-float-btn"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
      <button
        onClick={() => {
          window.scrollTo(0, 0);
        }}
        ref={scrollTopBtn}
        className="scroltop icon-up"
        type="button"
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    </>
  );
}

function MainLayout() {
  return (
    <div className="page-wraper">
      <Header2 />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer2 />
    </div>
  );
}
function MainLayout2() {
  return (
    <div className="page-wraper">
      <Header2 />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer2 />
    </div>
  );
}
function MainLayout3() {
  const [headerFix, setheaderFix] = useState(false);
  useEffect(() => {
    const onScroll = () => setheaderFix(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div className="page-wraper">
      <header className="site-header mo-left header header-transparent style-1">
        <div
          className={`sticky-header mt-3 main-bar-wraper navbar-expand-lg ${headerFix ? "is-fixed" : ""
            }`}
        >
          <Mainheader />
        </div>
      </header>
      <main id="main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default Index;
